import { ZaiPreference } from 'generated/graphql'
import type { TDatadogErrorLog } from 'utils/datadog/types'

import type { KnownPrePromptId } from './zai-hero.types'

export const GET_ZAI_PROMPTS_QUERY_LOG: TDatadogErrorLog = {
  from: 'src/modules/zai/zai-hero/index.tsx',
  name: 'Get Zai pre-prompts',
  message: 'Fetch Zai pre-prompts to list in HomePage',
}

export const PROMPT_ORDER_BY_USE_CASE: Record<ZaiPreference, KnownPrePromptId[]> = {
  [ZaiPreference.Soa]: [
    'share-of-attention-category',
    'brand-vs-competitors-performance',
    'weekly-most-engaged-videos',
    'report-weekly-insights',
    'explore-cultural-trends',
    'identify-audience-affinities',
  ],
  [ZaiPreference.Category]: [
    'report-weekly-insights',
    'explore-cultural-trends',
    'share-of-attention-category',
    'weekly-most-engaged-videos',
    'identify-audience-affinities',
    'brand-vs-competitors-performance',
  ],
  [ZaiPreference.Brand]: [
    'brand-vs-competitors-performance',
    'share-of-attention-category',
    'report-weekly-insights',
    'explore-cultural-trends',
    'weekly-most-engaged-videos',
    'identify-audience-affinities',
  ],
  [ZaiPreference.Territory]: [
    'report-weekly-insights',
    'explore-cultural-trends',
    'weekly-most-engaged-videos',
    'identify-audience-affinities',
    'brand-vs-competitors-performance',
    'share-of-attention-category',
  ],
}
